import { DoricPlugin } from "../DoricPlugin";
export class ShaderPlugin extends DoricPlugin {
    render(ret) {
        var _a;
        if (((_a = this.context.rootNode.viewId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (this.context.rootNode.viewId === ret.id) {
                this.context.rootNode.blend(ret.props);
            }
            else {
                for (let map of this.context.headNodes.values()) {
                    const viewNode = map.get(ret.id);
                    if (viewNode) {
                        viewNode.blend(ret.props);
                    }
                }
            }
        }
        else {
            this.context.rootNode.viewId = ret.id;
            this.context.rootNode.blend(ret.props);
        }
    }
}
